import { ReactElement } from 'react';

interface Props {
  className?: string;
}

function closeSidebar({ className }: Props): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 25 25"
      width="25"
      height="25"
      className={className}
    >
      <circle cx="12.5" cy="12.5" r="12.5" fill="url(#paint0_linear_17_55)" />
      <path
        fill="#fff"
        d="M5.447 13.366a1 1 0 010-1.732l9.83-5.675a1 1 0 011.5.866v11.35a1 1 0 01-1.5.866l-9.83-5.675z"
      />
      <defs>
        <linearGradient
          id="paint0_linear_17_55"
          x1="0"
          x2="25"
          y1="12.5"
          y2="12.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EF426F" />
          <stop offset="1" stopColor="#514689" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default closeSidebar;
